import { Box, Stack, Typography } from '@mui/material';
import PopUp from 'coreComponents/PopUp/PopUp';
import InstavisionButton from 'coreComponents/Button/Button';
import { AppBridge } from 'infrastructure/appBridge/appBridge';
import { APP_BRIDGE_CALLBACKS } from 'infrastructure/appBridge/appCallBacks';
import { useTranslation } from 'react-i18next';
import { PopupTypes } from 'typings/popUpTypes';
import { isRunningInWebView } from 'utils/webviewHelpers';
import { birdAssets } from 'partners/birdAssets';
import { Dispatch, SetStateAction } from 'react';
import { PopupIllustrationImage } from '../popupIllustrationStyle';

interface TCannotDeleteDefaultCardPopup {
  isPopUpOpen: boolean;
  setIsPopUpOpen: Dispatch<SetStateAction<boolean>>;
}

function CannotDeleteDefaultCardPopup({
  isPopUpOpen,
  setIsPopUpOpen
}: TCannotDeleteDefaultCardPopup) {
  const { t } = useTranslation('translation', {
    keyPrefix: 'components.cannotDeleteDefaultCardPopup'
  });

  // To do: Add App Callback here to take to live stream
  const handlePopUpBackButtonClick = () => {
    setIsPopUpOpen(false);
    AppBridge.sendMessageToApp(APP_BRIDGE_CALLBACKS.UPDATED_SUBSCRIPTION);
    AppBridge.sendMessageToApp(APP_BRIDGE_CALLBACKS.CLOSE_IN_APP_WEBVIEW);
  };

  const isWebViewPresent = isRunningInWebView();

  return (
    <PopUp isOpen={isPopUpOpen} type={PopupTypes.TYPE2}>
      <Stack direction="column" alignItems="center" marginBottom="30px">
        <Stack marginBottom="12px">
          <PopupIllustrationImage
            style={{ width: '220px', height: 'auto' }}
            src={birdAssets.CannotDeleteDefaultCardIllustration}
            alt="active-card-cannot-delete"
          />
          {/* <FreeTrialActivation width="300" height="250" /> */}
        </Stack>
        <Typography variant="title1" paddingBottom="12px">
          {t('title')}
        </Typography>
        <Box textAlign="center">
          <Typography variant="body2" padding="0px 12px" color="text.secondary">
            {t('cannotDeleteDefaultCard')}
          </Typography>
        </Box>
      </Stack>
      <Stack direction="column" alignItems="Stretch" marginBottom="6px">
        {isWebViewPresent ? (
          <InstavisionButton
            sx={{
              marginBottom: '16px'
            }}
            onClick={() => handlePopUpBackButtonClick()}
          >
            {t('okay')}
          </InstavisionButton>
        ) : (
          <InstavisionButton
            sx={{
              marginBottom: '16px'
            }}
            onClick={() => setIsPopUpOpen(false)}
          >
            {t('okay')}
          </InstavisionButton>
        )}
      </Stack>
    </PopUp>
  );
}
export default CannotDeleteDefaultCardPopup;
